"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var generatedConstants_1 = require("./generatedConstants");
var isRemoteVectorSet = function (setName) {
    return generatedConstants_1.remoteVectorSets.includes(setName);
};
exports.default = isRemoteVectorSet;
